<template>
  <CommonDialog
    v-if="isOpen"
    :isDialogOpened="isOpen"
    @handleCloseDialog="cancelAction && cancelAction()"
    width="500"
  >
    <v-card class="pa-1">
      <v-card-title class="d-flex justify-space-between mb-4">
        <span>{{ $t("player_registration.add_promo_code") }}</span>
        <v-btn icon color="red" @click="handleCancelAction" :disabled="loading">
          <v-icon size="20">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <label for="add-promo-code-modal__input">
          <input
            id="add-promo-code-modal__input"
            type="text"
            ref="addPromoCodeInputRef"
            class="add-promo-code-modal__input"
            v-model.trim="name"
            @keyup.enter="approveAction && approveAction(name)"
          />
          <VMessages :value="[errorMessage]" color="error" class="mt-1" />
        </label>
      </v-card-text>
      <v-card-actions class="d-flex justify-center">
        <CommonButton
          color="secondary"
          outlined
          :label="$t('common.cancel')"
          class="px-4"
          width="100"
          @handleClick="handleCancelAction"
          :disabled="loading"
        />
        <CommonButton
          :label="$t('common.add')"
          class="px-4"
          width="100"
          @handleClick="approveAction && approveAction(name)"
          :disabled="
            name.length < MIN_STORAGE_ITEM_NAME_LENGTH ||
              name.length > MAX_STORAGE_ITEM_NAME_LENGTH
          "
          :loading="loading"
        />
      </v-card-actions>
    </v-card>
  </CommonDialog>
</template>

<script>
import CommonButton from "../common/CommonButton";
import CommonDialog from "../common/dialog/CommonDialog";
import { ValidationLimitTypes } from "../enums/ValidationLimitTypes";

export default {
  name: "AddPromoCodeModal",
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    approveAction: {
      type: Function,
      required: true
    },
    cancelAction: {
      type: Function,
      required: true
    },
    errorMessage: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  components: {
    CommonButton,
    CommonDialog
  },

  data() {
    return {
      MIN_STORAGE_ITEM_NAME_LENGTH:
        ValidationLimitTypes.MIN_STORAGE_ITEM_NAME_LENGTH,
      MAX_STORAGE_ITEM_NAME_LENGTH:
        ValidationLimitTypes.MAX_STORAGE_ITEM_NAME_LENGTH,
      name: ""
    };
  },
  methods: {
    handleCancelAction() {
      this.cancelAction && this.cancelAction();
      this.name = "";
    }
  },

  watch: {
    isOpen(newValue) {
      if (newValue) {
        setTimeout(() => this.$refs.addPromoCodeInputRef.focus(), 200);
      } else {
        this.name = "";
      }
    }
  }
};
</script>

<style scoped>
.v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

.v-input__slot fieldset {
  height: 45px !important;
  font-size: 0.5rem;
}

.add-promo-code-modal__input {
  width: 100%;
  padding: 8px;
  font-size: 1rem;
  border: 2px solid var(--grey-color);
  border-radius: 5px;
  outline: none;
}

.add-promo-code-modal__input:focus {
  border: 2px solid var(--primary-color);
}
</style>
